import React, { Component } from 'react'
import { domains } from '../../lib/config'

export default class SelTrainingResources extends Component {
  render() {
    const cdnBase = `${domains.CDN_DOMAIN}/assets/pdfs/ssp/docs`

    return (
      <div>
        <h4>Training Resources</h4>
        <h6>Module 1</h6>
        <div className="rule-header" />
        <p>
          <a
            href={`${cdnBase}/Module1/K-5_Self-Regulation_Skills.pdf`}
            target="_blank"
          >
            Self-Regulation Skills and the New Elementary
            <em>Second Step</em> Program
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a href={`${cdnBase}/Module1/K-5_Visual_Review.pdf`} target="_blank">
            Visual Review of Research K–5
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <br />
        <h6>Module 2</h6>
        <div className="rule-header" />
        <p>
          <a
            href={`${cdnBase}/Module2/K-5_Program_Prep_Checklist.pdf`}
            target="_blank"
          >
            Program Preparation Checklist
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <h6>
          K–5
          <em>Second Step</em> Teaching Strategies
        </h6>
        <p>
          <em>Select your grade:</em>
          <a
            href="/kindergarten/teachers-counselors/second-step-kit/teach-reinforce/lesson-features/teaching-strategies"
            target="_blank"
          >
            {' '}
            Kindergarten
          </a>
          ,
          <a
            href="/grade-1/teachers-counselors/second-step-kit/teach-reinforce/lesson-features/teaching-strategies"
            target="_blank"
          >
            {' '}
            Grade 1
          </a>
          ,
          <a
            href="/grade-2/teachers-counselors/second-step-kit/teach-reinforce/lesson-features/teaching-strategies"
            target="_blank"
          >
            {' '}
            Grade 2
          </a>
          ,
          <a
            href="/grade-3/teachers-counselors/second-step-kit/teach-reinforce/lesson-features/teaching-strategies"
            target="_blank"
          >
            {' '}
            Grade 3
          </a>
          ,
          <a
            href="/grade-4/teachers-counselors/second-step-kit/teach-reinforce/lesson-features/teaching-strategies"
            target="_blank"
          >
            Grade 4
          </a>
          ,
          <a
            href="/grade-5/teachers-counselors/second-step-kit/teach-reinforce/lesson-features/teaching-strategies"
            target="_blank"
          >
            {' '}
            Grade 5
          </a>
        </p>
        <h6>Classroom Management Strategies</h6>
        <p>
          <em>Select your grade:</em>
          <a
            href="/kindergarten/teachers-counselors/second-step-kit/teach-reinforce/Lesson-Features/management-strategies"
            target="_blank"
          >
            {' '}
            Kindergarten
          </a>
          ,
          <a
            href="/grade-1/teachers-counselors/second-step-kit/teach-reinforce/Lesson-Features/management-strategies"
            target="_blank"
          >
            {' '}
            Grade 1
          </a>
          ,
          <a
            href="/grade-2/teachers-counselors/second-step-kit/teach-reinforce/Lesson-Features/management-strategies"
            target="_blank"
          >
            {' '}
            Grade 2
          </a>
          ,
          <a
            href="/grade-3/teachers-counselors/second-step-kit/teach-reinforce/Lesson-Features/management-strategies"
            target="_blank"
          >
            {' '}
            Grade 3
          </a>
          ,
          <a
            href="/grade-4/teachers-counselors/second-step-kit/teach-reinforce/Lesson-Features/management-strategies"
            target="_blank"
          >
            {' '}
            Grade 4
          </a>
          ,
          <a
            href="/grade-5/teachers-counselors/second-step-kit/teach-reinforce/Lesson-Features/management-strategies"
            target="_blank"
          >
            {' '}
            Grade 5
          </a>
        </p>
        <br />
        <h6>Module 3</h6>
        <div className="rule-header" />
        <h6>Anticipate, Reinforce, Reflect</h6>
        <p>
          <em>Select your grade:</em>
          <a
            href="/kindergarten/teachers-counselors/second-step-kit/teach-reinforce/reinforce-skills/arr-process"
            target="_blank"
          >
            {' '}
            Kindergarten
          </a>
          ,
          <a
            href="/grade-1/teachers-counselors/second-step-kit/teach-reinforce/reinforce-skills/arr-process"
            target="_blank"
          >
            {' '}
            Grade 1
          </a>
          ,
          <a
            href="/grade-2/teachers-counselors/second-step-kit/teach-reinforce/reinforce-skills/arr-process"
            target="_blank"
          >
            {' '}
            Grade 2
          </a>
          ,
          <a
            href="/grade-3/teachers-counselors/second-step-kit/teach-reinforce/reinforce-skills/arr-process"
            target="_blank"
          >
            {' '}
            Grade 3
          </a>
          ,
          <a
            href="/grade-4/teachers-counselors/second-step-kit/teach-reinforce/reinforce-skills/arr-process"
            target="_blank"
          >
            {' '}
            Grade 4
          </a>
          ,
          <a
            href="/grade-5/teachers-counselors/second-step-kit/teach-reinforce/reinforce-skills/arr-process"
            target="_blank"
          >
            {' '}
            Grade 5
          </a>
        </p>
        <h6>Formative Assessments</h6>
        <p>
          <em>Select your grade:</em>
          <a
            href="/kindergarten/Teachers-Counselors/Second-Step-Kit/Downloads/Student-Assessments"
            target="_blank"
          >
            {' '}
            Kindergarten
          </a>
          ,
          <a
            href="/grade-1/Teachers-Counselors/Second-Step-Kit/Downloads/Student-Assessments"
            target="_blank"
          >
            {' '}
            Grade 1
          </a>
          ,
          <a
            href="/grade-2/Teachers-Counselors/Second-Step-Kit/Downloads/Student-Assessments"
            target="_blank"
          >
            {' '}
            Grade 2
          </a>
          ,
          <a
            href="/grade-3/Teachers-Counselors/Second-Step-Kit/Downloads/Student-Assessments"
            target="_blank"
          >
            {' '}
            Grade 3
          </a>
          ,
          <a
            href="/grade-4/Teachers-Counselors/Second-Step-Kit/Downloads/Student-Assessments"
            target="_blank"
          >
            {' '}
            Grade 4
          </a>
          ,
          <a
            href="/grade-5/Teachers-Counselors/Second-Step-Kit/Downloads/Student-Assessments"
            target="_blank"
          >
            {' '}
            Grade 5
          </a>
        </p>
        <h6>
          Home Links <small>(PDF)</small>
        </h6>
        <p>
          <em>Select your grade:</em>
          <a href={`${cdnBase}/Module3/All_K_Home_Links.pdf`} target="_blank">
            {' '}
            Kindergarten
          </a>
          ,
          <a href={`${cdnBase}/Module3/All_G1_Home_Links.pdf`} target="_blank">
            {' '}
            Grade 1
          </a>
          ,
          <a href={`${cdnBase}/Module3/All_G2_Home_Links.pdf`} target="_blank">
            {' '}
            Grade 2
          </a>
          ,
          <a href={`${cdnBase}/Module3/All_G3_Home_Links.pdf`} target="_blank">
            {' '}
            Grade 3
          </a>
          ,
          <a href={`${cdnBase}/Module3/All_G4_Home_Links.pdf`} target="_blank">
            {' '}
            Grade 4
          </a>
          ,
          <a href={`${cdnBase}/Module3/All_G5_Home_Links.pdf`} target="_blank">
            {' '}
            Grade 5
          </a>
        </p>
        <h6>
          Spanish Home Links <small>(PDF)</small>
        </h6>
        <p>
          <em>Select your grade:</em>
          <a
            href={`${cdnBase}/Module3/All_K_Homelinks_Spanish.pdf`}
            target="_blank"
          >
            {' '}
            Kindergarten
          </a>
          ,
          <a
            href={`${cdnBase}/Module3/G1_ALL_Home_Links_Spanish.pdf`}
            target="_blank"
          >
            {' '}
            Grade 1
          </a>
          ,
          <a
            href={`${cdnBase}/Module3/G2_ALL_Home_Links_Spanish.pdf`}
            target="_blank"
          >
            {' '}
            Grade 2
          </a>
          ,
          <a
            href={`${cdnBase}/Module3/G3_All_Home_links_Spanish.pdf`}
            target="_blank"
          >
            {' '}
            Grade 3
          </a>
          ,
          <a
            href={`${cdnBase}/Module3/G4_All_Home_links_Spanish.pdf`}
            target="_blank"
          >
            {' '}
            Grade 4
          </a>
          ,
          <a
            href={`${cdnBase}/Module3/G5_All_Home_links_Spanish.pdf`}
            target="_blank"
          >
            {' '}
            Grade 5
          </a>
        </p>
        <h6>
          Summative Assessments for Teachers <small>(PDF)</small>
        </h6>
        <p>
          <em>Select your grade:</em>
          <a
            href={`${cdnBase}/Module3/K_Teacher_Summative_Assess.pdf`}
            target="_blank"
          >
            {' '}
            Kindergarten
          </a>
          ,
          <a
            href={`${cdnBase}/Module3/G1_Teacher_Summative_Assess.pdf`}
            target="_blank"
          >
            {' '}
            Grade 1
          </a>
          ,
          <a
            href={`${cdnBase}/Module3/G4_Teacher_Summative_Assess.pdf`}
            target="_blank"
          >
            {' '}
            Grade 4
          </a>
          ,
          <a
            href={`${cdnBase}/Module3/G5_Teacher_Summative_Assess.pdf`}
            target="_blank"
          >
            {' '}
            Grade 5
          </a>
        </p>
        <p>
          (<strong>Note: </strong>The teacher version of the Grade 2 and Grade 3
          assessments are found on the lesson card for Lesson 22.)
        </p>
        <h6>
          Summative Assessments for Students <small>(PDF)</small>
        </h6>
        <p>
          <em>Select your grade:</em>
          <a
            href={`${cdnBase}/Module3/K_Student_Summative_Assess.pdf`}
            target="_blank"
          >
            {' '}
            Kindergarten
          </a>
          ,
          <a
            href={`${cdnBase}/Module3/G1_Student_Summative_Assess.pdf`}
            target="_blank"
          >
            {' '}
            Grade 1
          </a>
          ,
          <a
            href={`${cdnBase}/Module3/G2_Student_Summative_Assess.pdf`}
            target="_blank"
          >
            {' '}
            Grade 2
          </a>
          ,
          <a
            href={`${cdnBase}/Module3/G3_Student_Summative_Assess.pdf`}
            target="_blank"
          >
            {' '}
            Grade 3
          </a>
          ,
          <a
            href={`${cdnBase}/Module3/G4_Student_Summative_Assess.pdf`}
            target="_blank"
          >
            {' '}
            Grade 4
          </a>
          ,
          <a
            href={`${cdnBase}/Module3/G5_Student_Summative_Assess.pdf`}
            target="_blank"
          >
            {' '}
            Grade 5
          </a>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/K-5_Lesson_Reflection_Log.pdf`}
            target="_blank"
          >
            Lesson-Reflection Log
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/K%E2%80%935_Success_Stories.pdf`}
            target="_blank"
          >
            Success Stories
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/ALL_Teacher_Lesson-Completion.pdf`}
            target="_blank"
          >
            Teacher Lesson-Completion Checklists K–5
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <h6>
          Lesson Reinforcement Checklist <strong>(PDF)</strong>
        </h6>
        <p>
          <em>Select your grade:</em>
          <a
            href={`${cdnBase}/Module3/K-3_Lesson-Reinforcement_Checklist.pdf`}
            target="_blank"
          >
            {' '}
            Kindergarten–Grade 3
          </a>
          ,
          <a
            href={`${cdnBase}/Module3/4-5_Teacher_Lesson_Delivery.pdf`}
            target="_blank"
          >
            {' '}
            Grade 4–5
          </a>
        </p>
        <p>
          <a
            href={`${cdnBase}/Module3/K-5_Lesson_Observation.pdf`}
            target="_blank"
          >
            Lesson Observation Form
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <br />
        <h6>Counselor-Teacher Toolkit</h6>
        <div className="rule-header" />
        <p>
          <a
            href={`${cdnBase}/Counselor-Teacher-Toolkit/Teacher_Counselor_Tasks_and_Tools.pdf`}
            target="_blank"
          >
            Implementation Roles, Tasks, and Tools Summary
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Counselor-Teacher-Toolkit/Sample_Yearly_Imp_Schedule.pdf`}
            target="_blank"
          >
            Yearly Implementation Schedule
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Counselor-Teacher-Toolkit/Data_Evaluation_Counselor_Model.pdf`}
            target="_blank"
          >
            Data Evaluation: Counselor Delivery Model
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Counselor-Teacher-Toolkit/Kick-Off_Meeting_Agenda_List.pdf`}
            target="_blank"
          >
            Kick-Off Meeting Agenda and Checklist
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Counselor-Teacher-Toolkit/Partnership_Kick-Off.ppt`}
            target="_blank"
          >
            Kick-off Meeting PowerPoint Presentation
          </a>{' '}
          <small>(1.8 MB)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Counselor-Teacher-Toolkit/K-5_Sample_Implementation_Plan.pdf`}
            target="_blank"
          >
            Sample Implementation Plan
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Counselor-Teacher-Toolkit/K-5_Implementation_Plan_Template.pdf`}
            target="_blank"
          >
            Implementation Plan Template
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <h6>
          Teacher Lesson-Reinforcement Checklist <small>(PDF)</small>
        </h6>
        <p>
          <em>Select your grade:</em>
          <a
            href={`${cdnBase}/Counselor-Teacher-Toolkit/K-3_Lesson-Reinforcement_Checklist.pdf`}
            target="_blank"
          >
            {' '}
            Kindergarten–Grade 3
          </a>
          ,
          <a
            href={`${cdnBase}/Counselor-Teacher-Toolkit/4-5_Teacher_Lesson_Delivery.pdf`}
            target="_blank"
          >
            {' '}
            Grade 4–5
          </a>
        </p>
        <h6>
          Counselor Lesson-Delivery and Reinforcement Checklists{' '}
          <small>(PDF)</small>
        </h6>
        <p>
          <em>Select your grade:</em>
          <a
            href={`${cdnBase}/Counselor-Teacher-Toolkit/K-3_Counselor_Lesson_Delivery_List.pdf`}
            target="_blank"
          >
            {' '}
            Kindergarten–Grade 3
          </a>
          ,
          <a
            href={`${cdnBase}/Counselor-Teacher-Toolkit/4-5__Counselor_Delivery_Checklist.pdf`}
            target="_blank"
          >
            {' '}
            Grade 4–5
          </a>
        </p>
        <p>
          <a
            href={`${cdnBase}/Counselor-Teacher-Toolkit/Check-In_Meeting_Agenda_List.pdf`}
            target="_blank"
          >
            Check-In Meeting Agenda and Checklist
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Counselor-Teacher-Toolkit/Wrap-Up_Meeting_Agenda_List.pdf`}
            target="_blank"
          >
            Wrap-Up Meeting Agenda and Checklist
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Counselor-Teacher-Toolkit/Yearly_Wrap-up_Meeting.ppt`}
            target="_blank"
          >
            Wrap-up Meeting PowerPoint Presentation
          </a>{' '}
          <small>(1.2 MB)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Counselor-Teacher-Toolkit/ALL_Counselor_Completion_Checklist.pdf`}
            target="_blank"
          >
            Counselor Lesson-Completion Checklists K–5
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Counselor-Teacher-Toolkit/ALL_Teacher_Lesson-Completion.pdf`}
            target="_blank"
          >
            Teacher Lesson-Completion Checklists K–5
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Counselor-Teacher-Toolkit/K-5_Lesson_Reflection_Log.pdf`}
            target="_blank"
          >
            Lesson Reflection Log
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p>
          <a
            href={`${cdnBase}/Counselor-Teacher-Toolkit/K%E2%80%935_Success_Stories.pdf`}
            target="_blank"
          >
            Success Stories Log
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p />
        <p>
          <a
            href={`${cdnBase}/Counselor-Teacher-Toolkit/K-5_Implementation_Survey.pdf`}
            target="_blank"
          >
            Implementation Survey
          </a>{' '}
          <small>(PDF)</small>
        </p>
        <p />
        <br />
        <br />
        <style jsx>
          {`
            h4 {
              font-size: 2rem;
              color: #f5961f;
              padding: 20px 0 5px 0;
            }

            h5 {
              font-weight: 100;
            }

            .rule-header {
              margin-bottom: 15px;
              width: 100%;
              height: 1px;
              overflow: hidden;
              margin-top: 0px;
              background-color: #ddd;
            }
          `}
        </style>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/static-training/SelTrainingResource.js